import { render, staticRenderFns } from "./SelectedVariantChips.vue?vue&type=template&id=65d1a486&scoped=true"
import script from "./SelectedVariantChips.vue?vue&type=script&lang=js"
export * from "./SelectedVariantChips.vue?vue&type=script&lang=js"
import style0 from "./SelectedVariantChips.vue?vue&type=style&index=0&id=65d1a486&prod&lang=scss&scoped=true"
import style1 from "./SelectedVariantChips.vue?vue&type=style&index=1&id=65d1a486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1a486",
  null
  
)

export default component.exports